export default function brand_details()
{
    return({
        //Company Information
        name: "DBE",
        subtitle: "Department of Basic Education",
        sub_entity_name: "Education Overview",
        sub_entity_subtitle: "National Progress",
        
        //Logo Information
        logo:getComputedStyle(document.documentElement)
        .getPropertyValue("--brand-short-logo")
        .replace(/['"]+/g, "")
    });
}
